export enum KanbanLogAction {
  Created = 'CREATED',
  Updated = 'UPDATED',
  CommentAdded = 'COMMENT_ADDED',
  CommentEdited = 'COMMENT_EDITED',
  CommentDeleted = 'COMMENT_DELETED',
}

export enum KanbanLogField {
  Status = 'status',
  Stage = 'stage',
  StageDeadline = 'stage_deadline',
  StageDetails = 'stage_details',
  KanbanPriority = 'kanban_priority',
  Agent = 'agent_id',
  Deadline = 'deadline',
  Assignee = 'assignee_id',
  Creator = 'creator_id',
  TeamOwner = 'team_owner',
  TaskType = 'task_type',
  Resolution = 'resolution',
  WaitingReason = 'waiting_reason',
  CustomerOutcome = 'customer_outcome',
  CancelReason = 'cancel_reason',
  Comment = 'comment',
  ExtraFields = 'extra_fields',
  ExitRequestDate = 'exit_request_date',
  ExitDate = 'exit_date',
  ExitReason = 'exit_reason',
}